"use client";

// Scoped to the public (site) segment. The layout (nav, footer, background)
// still renders around this — it replaces only the failed page content.
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";

export default function SiteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Site error:", error);
  }, [error]);

  return (
    <div className="h-[calc(100dvh_-_var(--header-height))] overflow-hidden flex flex-col items-center justify-center gap-4 text-center">
      <div className="font-bold text-white leading-12">
        <h1 className="text-2xl inline-block mr-4 border-white border-r pr-4 leading-12">
          500
        </h1>
        <div className="inline-block">
          <h2 className="uppercase text-2xl">Something Went Wrong</h2>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button onClick={reset}>Try again</Button>
        <Button variant="link" asChild>
          <Link href="/">Return Home</Link>
        </Button>
      </div>
    </div>
  );
}
